import store from '@/store/index';

export default {
    beforeEach: [
        ({ meta = {} }, from, next) => {
            if (!window.sfe.prerender) {
                if (meta.pre_symbol) store.dispatch('settings/GET_SYMBOLS');
            }

            next();
        },
    ],
};
